import { c as _c } from "react/compiler-runtime";
import { getFieldErrors } from '@onefootprint/core';
import { getErrorCode } from '@onefootprint/fetch-hosted';
import { useRequestError } from '@onefootprint/fetch-hosted/use-request-error';
import { useTranslateFieldError } from '@/idv2/hooks/use-vault-mutation-error';

/**
 * Returns a function that extracts a user-facing error message from a vault mutation error.
 * For T120 (validation) errors, returns the field's error in the session language.
 * Falls back to the generic error message otherwise.
 */
export const useVaultErrorMessage = () => {
  const $ = _c(3);
  const {
    getErrorMessage
  } = useRequestError();
  const translateFieldError = useTranslateFieldError();
  let t0;
  if ($[0] !== getErrorMessage || $[1] !== translateFieldError) {
    t0 = (error, field) => {
      const fieldErrors = getErrorCode(error) === "T120" ? getFieldErrors(error) : [];
      const fieldError = fieldErrors.find(e => e.key === field);
      return fieldError ? translateFieldError(fieldError).message : getErrorMessage(error);
    };
    $[0] = getErrorMessage;
    $[1] = translateFieldError;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};